// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandCoinsIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.791 17.633a3.055 3.055 0 0 0-2.655-.53l-5.23 1.203A3.499 3.499 0 0 0 17.5 14h-6.258a3.978 3.978 0 0 0-2.828 1.171L5.586 18H2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h13c.082 0 .163-.01.242-.03l8-2a.868.868 0 0 0 .15-.05l4.858-2.068.055-.024a3.074 3.074 0 0 0 .491-5.195h-.005ZM2 20h3v5H2v-5Zm25.429 1.026-4.75 2.023L14.875 25H7v-5.586l2.829-2.828A1.981 1.981 0 0 1 11.242 16H17.5a1.5 1.5 0 1 1 0 3H14a1 1 0 0 0 0 2h4c.075 0 .15-.009.224-.025l8.375-1.926.038-.01a1.075 1.075 0 0 1 .788 1.987h.004ZM20.5 12c.247 0 .494-.02.738-.06a4.5 4.5 0 1 0 3.527-5.875A4.5 4.5 0 1 0 20.5 12Zm7.5-1.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM20.5 5a2.5 2.5 0 0 1 2.406 1.826 4.501 4.501 0 0 0-1.875 3.117A2.5 2.5 0 1 1 20.5 5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
